import { userService } from '../../helpers/auth/user.service';

const user = localStorage.getItem('user');
const parseUser = (user && user != 'undefined') ? JSON.parse(user) : null
export const state = parseUser
    ? { status: { loggedUser: true }, user }
    : { status: { loggedUser: false }, user: null };

export const getters = {
    user: state => state.user,
    status: state => state.status
}

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async login ({ dispatch, commit }, { username, password }) {
        try {
            const user = await userService.login(username, password)
            commit('loginSuccess', user);
            if (user.user.role === 'rpo') {
                return true
            } else {
                commit('loginFailure', 'User not allowed to login');
                dispatch('notification/error', 'User not allowed to login', { root: true });
                return false
            }
        } catch (error) {
            commit('loginFailure', error.response.data.message);
            dispatch('notification/error', error.response.data.message, { root: true });
            return false
        }
    },

    async validate ({ dispatch }) {
        try {
            await userService.validate()
            return true
        } catch (error) {
            if (error.response && error.response.data) {
                dispatch('notification/error', error.response.data.message, { root: true });
            }
            return false
        }
    },

    // Logout the user
    logout ({ commit }) {
        userService.logout();
        commit('logout');
    }
};

export const mutations = {
    loginSuccess (state, user) {
        state.status = { loggedUser: true };
        state.user = user;
    },
    loginFailure (state) {
        state.status = {};
        state.user = null;
    },
    logout (state) {
        state.status = {};
        state.user = null;
    }
};

